import { compareHelpers, miscHelpers } from '@approvalmax/utils';
import { useMemo } from 'react';
import { CurrencyIsoCode, useGetWallets } from 'shared/data/wallets/v1';
import { useCompanyBasedOnUrl } from 'shared/hooks';

import { currenciesPriority } from './TransactionsFilter.constants';

export const useAvailableCurrencies = () => {
    const company = useCompanyBasedOnUrl();

    const { data, isLoading } = useGetWallets({
        path: { organizationId: company.id },
    });

    const currencies = useMemo(() => {
        return data?.items
            .reduce<
                {
                    id: CurrencyIsoCode;
                    name: string;
                }[]
            >((acc, wallet) => {
                if (wallet.isVisible && wallet.isPayable) {
                    const currency = miscHelpers.castToEnum(CurrencyIsoCode, wallet.currency.code);

                    if (currency) {
                        acc.push({
                            id: currency,
                            name: wallet.currency.code,
                        });
                    }
                }

                return acc;
            }, [])
            .sort((a, b) => {
                const aPriorityIndex = currenciesPriority.indexOf(a.id);
                const bPriorityIndex = currenciesPriority.indexOf(b.id);

                if (aPriorityIndex !== -1 && bPriorityIndex !== -1) {
                    return aPriorityIndex - bPriorityIndex;
                }

                if (aPriorityIndex !== -1 && bPriorityIndex === -1) {
                    return -1;
                }

                if (aPriorityIndex === -1 && bPriorityIndex !== -1) {
                    return 1;
                }

                return compareHelpers.stringComparator2Asc(a.name, b.name);
            });
    }, [data]);

    return {
        currencies,
        isLoading,
    };
};
